import React, { useMemo } from 'react';
import i18next from 'i18next';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DefaultModal from './DefaultModal';
import { ModalsSelectors, ProjectsSelectors } from '../../redux/selectors';

const AccessToProjectBlocked = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const isShownModal = useSelector(ModalsSelectors.selectAccessToProjectBlockedModalIsOpen);
  const [project] = useSelector(ProjectsSelectors.selectAllProjects);

  const editor = useMemo(() => project?.editor, [project]);

  const closeModal = () => {};
  const primaryAction = () => {};
  const signOut = () => {
    navigate('/logout');
  };

  return (
    <DefaultModal
      isShown={isShownModal}
      closeModal={closeModal}
      primaryAction={primaryAction}
      secondaryAction={signOut}
      title={t('accessToProjectBlocked.title', { ns: i18next.Namespace.COMMON })}
      message={(
        <>
          {t('accessToProjectBlocked.msg', { ns: i18next.Namespace.COMMON })}
          {editor && <>&nbsp;<a style={{ color: '#FF1100' }} href={`mailto:${editor.email}`}>{editor.email}</a>.</>}
        </>
      )}
      secondaryBtnText={t('button.signOut', { ns: i18next.Namespace.COMMON })}
    />
  );
};

export default AccessToProjectBlocked;
